import { render, staticRenderFns } from "./workPermitDisplay.vue?vue&type=template&id=9251d9ee&scoped=true"
import script from "./workPermitDisplay.vue?vue&type=script&lang=js"
export * from "./workPermitDisplay.vue?vue&type=script&lang=js"
import style0 from "./workPermitDisplay.vue?vue&type=style&index=0&id=9251d9ee&lang=sass"
import style1 from "./workPermitDisplay.vue?vue&type=style&index=1&id=9251d9ee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9251d9ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9251d9ee')) {
      api.createRecord('9251d9ee', component.options)
    } else {
      api.reload('9251d9ee', component.options)
    }
    module.hot.accept("./workPermitDisplay.vue?vue&type=template&id=9251d9ee&scoped=true", function () {
      api.rerender('9251d9ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/dashboard/workPermitDisplay.vue"
export default component.exports